import React, { useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";


const ModalQuestao = ({
  answers,
  showModal,
  setShowModal,
}) => {

  const checkPontuacao = (pontos)=>{
    if(pontos>=100) return 'Atendimento total';
    if(pontos>=75 && pontos <100) return 'Atendimento parcial';
    if(pontos>=50 && pontos <75) return 'Atendimento moderado';
    if(pontos>=25 && pontos <50) return 'Atendimento básico';
    if(pontos>=1 && pontos <25) return 'Atendimento falho';
    if(pontos<1) return 'Atendimento inexistente';
  }
 
  return (
    <>
      {answers && showModal !== undefined && setShowModal && (
        <Modal
          // style={{width:'80%',justifyContent:'center',alignItems:'center'}}
          show={showModal === true}
          dialogClassName="modal_width"
          onHide={() => setShowModal(false)}
        >
          <Modal.Header closeButton closeLabel="">
            <Modal.Title>
              Resultado
              <br />
            </Modal.Title>
           
          </Modal.Header>
           <Modal.Body>
              <div>
                <p style={{fontSize:18}}><b>P1.C1: </b>{(answers['1_1']/answers['1_2'])*33.34}</p>
                <p style={{fontSize:18}}><b>P1.C2: </b>{(answers['2_1']/answers['2_2'])*16.67}</p>
                <p style={{fontSize:18}}><b>P2.C2: </b>{(answers['3_1']/answers['3_2'])*16.67}</p>
                <p style={{fontSize:18}}><b>P1.C3: </b>{(answers['4_1']/answers['4_2'])*16.67}</p>
                <p style={{fontSize:18}}><b>P2.C3: </b>{(answers['5_1']/answers['5_2'])*16.67}</p>

                <p style={{fontSize:18,marginTop:50}}><b>Pontuação final: </b>{parseFloat(((answers['1_1']/answers['1_2'])*33.34)+((answers['2_1']/answers['2_2'])*16.67)
                +((answers['3_1']/answers['3_2'])*16.67)+((answers['4_1']/answers['4_2'])*16.67)+((answers['5_1']/answers['5_2'])*16.67)).toFixed(2)}</p>

                {<p style={{fontSize:18}}><b>Resultado:</b> {checkPontuacao(parseFloat(((answers['1_1']/answers['1_2'])*33.34)+((answers['2_1']/answers['2_2'])*16.67)
                +((answers['3_1']/answers['3_2'])*16.67)+((answers['4_1']/answers['4_2'])*16.67)+((answers['5_1']/answers['5_2'])*16.67)))}</p>}





              </div>
            </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ModalQuestao;
